import theme from '../Theme';

const styles = () => ({
  pinTitle: {
    fontSize: theme.font.size.sm,
    lineHeight: theme.font.lineHeight.sm,
    color: theme.colors.mainText,
    marginTop: '-14px',
    paddingTop: '4px',
    fontWeight: theme.font.weight.bold,
    textAlign: 'center',
    textShadow: '-2px 0 white, 0 2px white, 2px 0 white, 0 -2px white',
  },
  markerTooltip: {
    zIndex: -6,
    color: 'transparent',
    background: 'transparent',
    border: 'none',
    boxShadow: 'none',
  },
  marker: {},
  popUp: {
    '& .leaflet-popup-content-wrapper, & .leaflet-popup-content': {
      margin: '0',
      padding: '0 !important',
      width: '310px',
      boxSizing: 'border-box',
    },

    [theme.screenSize.mobile]: {
      '& .leaflet-popup-content, & .leaflet-popup-content-wrapper': {
        maxWidth: '343px',
        width: '100%',

        overflow: 'hidden',
      },
    },
  },
});

export default styles;
